/* ECDF v6 (page B = /products/ai-translator-e, template product.ecdf-v6-offer only).
   Drives Shrine's NATIVE buy box (quantity-breaks tiles + product_upsell add-on checkboxes + quantity-gifts + product form); it never adds to the cart by itself:
   - live YOUR ORDER receipt, button label "Add to cart · $X", sticky bar text;
   - each add-on only on its own tile (case on 1 translator, wallet on 2), unticked when the tile changes;
   - step-up sheet once per session on the 1-translator tile (window.E6CFG.stepup), line property _su=1/0;
   - sticky bar + chooser sheet (mobile); Finder Tag slot (only when the funnel section switch is on);
   - hides the email popup on this page only (E6CFG.hideKlaviyo). */
(function () {
  'use strict';
  var d = document, W = window, CFG = W.E6CFG || {};
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var ss = { get: function (k) { try { return W.sessionStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { W.sessionStorage.setItem(k, v); } catch (e) {} } };

  function klaviyo() {
    if (CFG.hideKlaviyo === false) return;
    var busy = false, B = d.body;
    var kill = function () {
      busy = false;
      $$('div[class*="kl-private-reset-css"][role="dialog"]').forEach(function (n) { n.remove(); });
      /* Klaviyo locks the page with body.klaviyo-prevent-body-scrolling (overflow:hidden !important): lift it once its modal is gone */
      if (B.classList.contains('klaviyo-prevent-body-scrolling') && !$('div[class*="kl-private-reset-css"][role="dialog"]')) B.classList.remove('klaviyo-prevent-body-scrolling');
    };
    kill();
    if (W.MutationObserver) new MutationObserver(function () { if (!busy) { busy = true; (W.requestAnimationFrame || setTimeout)(kill); } })
      .observe(B, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    klaviyo();
    var P; try { P = JSON.parse($('#e6-prices').textContent); } catch (e) { return; }
    var qb = $('.main-product__info-container quantity-breaks') || $('quantity-breaks');
    if (!qb) return;
    var info = qb.closest('.main-product__info-container') || qb.closest('product-info') || d.body;
    var rc = $('#e6-rcpt'), su = $('#e6-su'), ch = $('#e6-ch'), st = $('#e6-sticky');
    var bypass = false, lastQ = 0, ftBox = null;

    function atc() { return $('.product-form__submit', info); }
    function tier() {
      var i = $('input[name="quantity"]:checked', qb); if (!i) return null;
      var l = $('label[for="' + i.id + '"]', qb);
      var q = parseInt(i.value, 10) || 1, base = parseInt(qb.dataset.basePrice, 10) || P.unit;
      var fx = parseInt(l && l.dataset.fixedDiscount, 10) || 0;
      return { q: q, input: i, label: l, list: base * q, price: base * q - fx };
    }
    function input(q) { return $('input[name="quantity"][value="' + q + '"]', qb); }
    function priceOf(q) { var i = input(q), l = i && $('label[for="' + i.id + '"]', qb); if (!l) return 0;
      var base = parseInt(qb.dataset.basePrice, 10) || P.unit; return base * q - (parseInt(l.dataset.fixedDiscount, 10) || 0); }
    function allowed(h, q) { return (h === P.caseH && q === 1) || (h === P.walletH && q === 2); }
    function up(h, sel) { return $('.upsell[data-handle="' + h + '"]' + (sel ? '[data-selected="true"]' : ''), info); }
    function picked(t) {
      return { c: t.q === 1 && !!up(P.caseH, 1), w: t.q === 2 && !!up(P.walletH, 1) };
    }
    /* each add-on belongs to one tile (case: 1 translator, wallet: 2); untick it when another tile is chosen */
    function tidy(t) {
      info.classList.remove('e6-q1', 'e6-q2', 'e6-q3'); info.classList.add('e6-q' + Math.min(t.q, 3));
      [P.caseH, P.walletH].forEach(function (h) {
        if (allowed(h, t.q)) return;
        var u = up(h, 1); if (u) ($('.upsell-toggle-btn', u) || u).click();
      });
    }
    function sub(t, o) { return t.price + (o.c ? P['case'] : 0) + (o.w ? P.wallet : 0); }
    function packName(q) { return q + (q === 1 ? ' translator' : ' translators'); }

    function render() {
      var t = tier(); if (!t) return;
      if (t.q !== lastQ) { lastQ = t.q; tidy(t); }
      var o = picked(t), s = sub(t, o), ship = s >= P.free ? 0 : P.ship, L = [];
      var FREE = '<b class="e6-free">FREE</b>';
      L.push([t.q + ' x ECDF AI Translator',
        (t.list > t.price ? '<s>' + money(t.list) + '</s> ' : '') + '<b>' + money(t.price) + '</b>']);
      if (t.q >= 2) L.push([t.q + ' carrying cases', FREE + ' <small>(' + money(P['case'] * t.q) + ' value)</small>']);
      if (t.q >= 3) L.push(['Smart Wallet (black)', FREE + ' <small>(' + money(P.wallet) + ' value)</small>']);
      if (o.c) L.push(['Carrying case', money(P['case'])]);
      if (o.w) L.push(['Smart Wallet (black)', money(P.wallet)]);
      L.push(['Tracked shipping', ship ? money(ship) : FREE]);
      var html = L.map(function (r) { return '<li><span>' + r[0] + '</span><span>' + r[1] + '</span></li>'; }).join('') +
        '<li class="e6-rcpt-tot"><span>Total with shipping</span><span>' + money(s + ship) + '</span></li>';
      if (rc) {
        var ul = $('[data-e6="lines"]', rc); if (ul && ul.innerHTML !== html) ul.innerHTML = html;
        var sv = $('[data-e6="save"]', rc), save = t.list - t.price;
        var txt = t.q === 2 ? 'You save ' + money(save) + ' + 2 free cases' :
          t.q >= 3 ? 'You save ' + money(save) + ' + ' + money(P['case'] * t.q + P.wallet) + ' of free extras' : '';
        if (sv) { sv.textContent = txt; sv.hidden = !txt; }
      }
      var b = atc(), lb = b && ($('.main-atc__label__text', b) || $('span', b));
      var verb = t.q === 1 ? 'Add to cart' : 'Add ' + t.q + ' to cart';
      if (lb) lb.textContent = verb + ' · ' + money(s);
      $$('[data-e6="ch-verb"]').forEach(function (x) { x.textContent = verb; });
      var sp = $('[data-e6="st-pack"]'), sr = $('[data-e6="st-price"]');
      if (sp) sp.textContent = packName(t.q); if (sr) sr.textContent = money(s);
      var sx = $('[data-e6="st-extra"]'); if (sx) sx.textContent = t.q === 2 ? ' · 2 free cases' : t.q >= 3 ? ' · free shipping' : '';
      $$('[data-e6="ch-price"]').forEach(function (x) { x.textContent = money(s); });
      $$('.e6-ch-o').forEach(function (x) { x.setAttribute('aria-checked', String(parseInt(x.dataset.e6Pick, 10) === t.q)); });
      var no = $('[data-e6="su-no"]'); if (no) no.textContent = money(s);
      /* step-up rows follow the live 1-translator subtotal (case ticked or not) */
      if (t.q === 1) { var p2 = priceOf(2), one = $('[data-e6="su-one"]'), ol = $('[data-e6="su-one-l"]'), mo = $('[data-e6="su-more"]'), cs = $('[data-e6="su-case"]');
        if (one) one.textContent = money(s); if (ol) ol.textContent = o.c ? '1 translator + case' : '1 translator';
        if (mo && p2) mo.textContent = money(p2 - s).replace('.00', ''); if (cs) cs.hidden = !o.c; }
    }
    var tm = 0, later = function () { clearTimeout(tm); tm = setTimeout(render, 60); };
    qb.addEventListener('change', later); info.addEventListener('click', later);
    if (W.MutationObserver) new MutationObserver(later).observe(info, { subtree: true, attributes: true, attributeFilter: ['data-selected'] });

    /* hidden line property for the step-up read-out (_su=1 yes / 0 no) */
    function suProp(v) {
      var b = atc(); if (!b) return;
      var f = b.form || (b.getAttribute('form') && d.getElementById(b.getAttribute('form'))) || b.closest('form'); if (!f) return;
      var el = f.querySelector('input[name="properties[_su]"]');
      if (!el) { el = d.createElement('input'); el.type = 'hidden'; el.name = 'properties[_su]'; f.appendChild(el); }
      el.value = v;
      clearTimeout(suProp.t); suProp.t = setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 2500);
    }
    function go() {
      var b = atc(); if (!b) return;
      var tag = ftBox && ftBox.checked ? ftBox.value : null;
      var fire = function () { bypass = true; b.click(); };
      if (tag) {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(tag, 10), quantity: 1 }] }) }).then(fire, fire);
      } else fire();
    }

    /* sheets */
    var lastFocus = null;
    function open(el) { if (!el) return; lastFocus = d.activeElement; el.hidden = false; d.documentElement.classList.add('e6-lock');
      requestAnimationFrame(function () { el.classList.add('e6-on'); var f = $('.e6-btn', el); if (f) f.focus({ preventScroll: true }); }); }
    function close(el) { if (!el || el.hidden) return; el.classList.remove('e6-on'); el.hidden = true;
      if (!$('.e6-sheet:not([hidden])')) d.documentElement.classList.remove('e6-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
    $$('.e6-sheet [data-e6-close]').forEach(function (x) {
      x.addEventListener('click', function () { var sh = x.closest('.e6-sheet'); if (sh === su) { suNo(); return; } close(sh); });
    });
    /* closing the step-up sheet counts as "No thanks": the tap on Add to cart is never lost */
    function suNo() { ss.set('e6su', 'x'); suProp('x'); close(su); setTimeout(function () { render(); go(); }, 0); }
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.e6-sheet:not([hidden])').forEach(function (sh) { if (sh === su) suNo(); else close(sh); }); });

    /* step-up: intercept Shrine's own button (capture phase) before its form submits */
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-form__submit');
      if (!b || !info.contains(b)) return;
      if (bypass) { bypass = false; return; }
      var t = tier(); if (!t) return;
      var need = CFG.stepup !== false && su && t.q === 1 && !ss.get('e6su');
      var tag = ftBox && ftBox.checked;
      if (!need && !tag) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (need) { render(); open(su); } else go();
    }, true);
    if (su) $$('[data-e6-su]', su).forEach(function (x) {
      x.addEventListener('click', function () {
        var yes = x.dataset.e6Su === '1';
        ss.set('e6su', yes ? '1' : '0'); suProp(yes ? '1' : '0'); close(su);
        if (yes) { var i = input(2); if (i && !i.checked) i.click(); }
        setTimeout(function () { render(); go(); }, yes ? 260 : 0);
      });
    });

    /* chooser sheet + sticky bar */
    $$('[data-e6-open]').forEach(function (x) { x.addEventListener('click', function () { render(); open(d.getElementById(x.dataset.e6Open)); }); });
    $$('[data-e6-pick]').forEach(function (x) {
      x.addEventListener('click', function () { var i = input(x.dataset.e6Pick); if (i && !i.checked) i.click(); later(); });
    });
    $$('[data-e6-atc]').forEach(function (ca) { ca.addEventListener('click', function () { close(ch); var b = atc(); if (b) b.click(); }); });
    /* long form: "Choose" buttons select their tile (data-e6-pick) and bring the buy box back on screen; reviews "show more" */
    $$('[data-e6-up]').forEach(function (x) { x.addEventListener('click', function () { setTimeout(function () { qb.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 40); }); });
    $$('[data-e6-more]').forEach(function (x) { x.addEventListener('click', function () { $$('#e6-reviews .e6-more').forEach(function (n) { n.classList.remove('e6-more'); }); x.remove(); }); });
    if (st) {
      var fin = $('#e6-final'), raf = 0;
      var upd = function () {
        raf = 0; var btn = atc(); if (!btn) return;
        var past = btn.getBoundingClientRect().bottom < 0, f = fin ? fin.getBoundingClientRect() : null;
        var on = past && !(f && f.top < W.innerHeight);
        st.classList.toggle('e6-on', on); st.setAttribute('aria-hidden', String(!on));
        var sb = $('.e6-sticky-b', st); if (sb) sb.tabIndex = on ? 0 : -1;
      };
      var tick = function () { if (!raf) raf = (W.requestAnimationFrame || setTimeout)(upd); };
      W.addEventListener('scroll', tick, { passive: true }); W.addEventListener('resize', tick); upd();
    }

    /* rating chip + Finder Tag slot (only rendered by the funnel section when their switches are on) */
    var cht = $('#e6-chip-tpl'), chs = $('#e6-chip-slot');
    if (cht && chs) chs.appendChild(cht.content.cloneNode(true));
    var ftt = $('#e6-ft-tpl');
    if (ftt && CFG.ft) { var w = d.createElement('div'); w.className = 'e6'; w.appendChild(ftt.content.cloneNode(true)); qb.parentNode.insertBefore(w, qb.nextSibling);
      ftBox = $('[data-e6-ft]', w); ftBox.addEventListener('change', later); }

    /* the store menu points at the other translator page: on this page it points here */
    $$('a[href*="/products/smart-voice-language-companion"]').forEach(function (a) { a.setAttribute('href', a.getAttribute('href').replace('/products/smart-voice-language-companion', '/products/ai-translator-e')); });
    render(); W.addEventListener('load', later);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
